"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import BookDemoModal from "../components/BookDemoModal";

export default function CTABanner() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const router = useRouter();
  return (
    <section className="w-full bg-surface-raised py-16 lg:py-20 px-6 md:px-10 lg:px-16">
      <div className="max-w-[920px] mx-auto">
        <div className="bg-[#1e293b] rounded-3xl px-10 py-16 lg:py-20 text-center">
          <h2 className="text-3xl lg:text-4xl xl:text-[44px] font-black text-white leading-tight tracking-[-0.02em] mb-4">
            Ready to lead the AI<br />search revolution?
          </h2>
          <p className="text-[15px] text-blue-100 max-w-[440px] mx-auto leading-relaxed mb-10">
            Experience the power of sophisticated AI visibility tools designed
            for modern marketing teams.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-7 py-3 bg-accent text-on-accent font-semibold text-[15px] rounded-xl hover:bg-accent/90 transition-colors duration-150 cursor-pointer"
            >
              Book an Audit Call
            </button>
            <button
              onClick={() => router.push("/lead-generation")}
              className="px-7 py-3 border border-white/50 text-white font-semibold text-[15px] rounded-xl hover:border-white transition-colors duration-150 cursor-pointer"
            >
              Contact Sales
            </button>
          </div>
        </div>
      </div>

      <BookDemoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
}
